import { combineReducers } from "redux";
import dataSliceReducer from "./dataSlice";
import menuSliceReducer from "./menuSlice";

export default combineReducers({
  dataState: dataSliceReducer,
  menuState: menuSliceReducer,
});